import { AuthMFAVerification } from 'sections/auth/auth-forms/AuthMFAVerification';
import AuthWrapper from 'sections/auth/AuthWrapper';

export function MfaVerification() {
    return (
        <AuthWrapper>
            <AuthMFAVerification />
        </AuthWrapper>
    );
}
